import { render, staticRenderFns } from "./BotsSettings.vue?vue&type=template&id=723c18dc&scoped=true"
import script from "./BotsSettings.vue?vue&type=script&lang=js"
export * from "./BotsSettings.vue?vue&type=script&lang=js"
import style0 from "./BotsSettings.vue?vue&type=style&index=0&id=723c18dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723c18dc",
  null
  
)

export default component.exports